module.exports = __webpack_public_path__ + "static/media/F.e3e18ca7.svg";